/* TODO make sure
 * 1 if first block - start replacing from end
 * if whole - must be replaced whole
 * if last block - start replacing from start
 * if standalone - must have info which one to replace (eg when selecting one letter in whole paragraph)
 *
 * 2 text = '<b>Hello<b> world', highlightText = '<b>lo<b> world'
 *
 */
import { HIGHLIGHT_CONTAINER_CLASS } from '../constants';

export const withHighlightAsText = (text: string, highlightText?: string) => {
  if (!highlightText) {
    return text;
  }

  return text.replace(highlightText, `<span class="${HIGHLIGHT_CONTAINER_CLASS}">${highlightText}</span>`);
};
